import React, { FC, KeyboardEvent, useCallback } from 'react';
import styled from 'astroturf/react'

import Modal from 'js/components/modals/Modal';
import { Button as ButtonBase } from 'js/design_system/Button';
import { TextButton as TextButtonBase } from 'js/design_system/TextButton';
import { Heading as HeadingBase } from 'js/design_system/Heading';
import { Colors } from 'js/design_system/Color';
import CloseIcon from 'js/design_system/icons/close.svg';
import _Button from "ConfirmationModal-Button.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/ConfirmationModal/ConfirmationModal.tsx?styleId=Button";
import _TextButton from "ConfirmationModal-TextButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/ConfirmationModal/ConfirmationModal.tsx?styleId=TextButton";
import _Buttons from "ConfirmationModal-Buttons.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/ConfirmationModal/ConfirmationModal.tsx?styleId=Buttons";
import _ButtonGroup from "ConfirmationModal-ButtonGroup.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/ConfirmationModal/ConfirmationModal.tsx?styleId=ButtonGroup";
import _CloseButton from "ConfirmationModal-CloseButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/ConfirmationModal/ConfirmationModal.tsx?styleId=CloseButton";
import _Heading from "ConfirmationModal-Heading.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/ConfirmationModal/ConfirmationModal.tsx?styleId=Heading";
import _HeadingGroup from "ConfirmationModal-HeadingGroup.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/ConfirmationModal/ConfirmationModal.tsx?styleId=HeadingGroup";
import _Content from "ConfirmationModal-Content.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/ConfirmationModal/ConfirmationModal.tsx?styleId=Content";
import _styles from "ConfirmationModal-styles.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/ConfirmationModal/ConfirmationModal.tsx?styleId=styles";


const Button = /*#__PURE__*/styled(ButtonBase, null, {
  displayName: "Button",
  styles: _Button
});

const TextButton = /*#__PURE__*/styled(TextButtonBase, null, {
  displayName: "TextButton",
  styles: _TextButton
});

const Buttons = /*#__PURE__*/styled("div", null, {
  displayName: "Buttons",
  styles: _Buttons
});

const ButtonGroup = /*#__PURE__*/styled("div", null, {
  displayName: "ButtonGroup",
  styles: _ButtonGroup
});

const CloseButton = /*#__PURE__*/styled(TextButtonBase, null, {
  displayName: "CloseButton",
  styles: _CloseButton
});

const Heading = /*#__PURE__*/styled(HeadingBase, null, {
  displayName: "Heading",
  styles: _Heading
});

const HeadingGroup = /*#__PURE__*/styled("div", null, {
  displayName: "HeadingGroup",
  styles: _HeadingGroup
});

const Content = /*#__PURE__*/styled("div", null, {
  displayName: "Content",
  styles: _Content
});

const styles = _styles;

type Props = {
  heading?: string;
  content: React.ReactNode;
  action: string;
  disableAction: boolean;
  /**
   * Clicking outside the modal, clicking Cancel,
   * or clicking the close 'X' calls this function.
   */
  onClose: () => void;
  /**
   * This function is called when a user clicks the primary action
   * button.
   */
  onAction: () => void;
};

const ConfirmationModal: FC<Props> = ({
  heading,
  content,
  action,
  disableAction,
  onClose,
  onAction,
}) => {
  const closeModalOnEscape = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Escape') {
        onClose();
      }
    },
    [onClose],
  );

  return (
    <Modal
      backdropClassName={styles.backdrop}
      className={styles.modal}
      onClose={onClose}
      containerProps={{
        onKeyDown: closeModalOnEscape,
      }}
    >
      <HeadingGroup border={!!heading}>
        <Heading size="sm">{heading}</Heading>

        <CloseButton aria-label="Close" onClick={onClose}>
          <CloseIcon color={Colors.GrayDark} />
        </CloseButton>
      </HeadingGroup>

      <Content>{content}</Content>

      <Buttons>
        <ButtonGroup>
          <TextButton inline onClick={onClose}>
            Cancel
          </TextButton>
          <Button disabled={disableAction} onClick={onAction}>
            {action}
          </Button>
        </ButtonGroup>
      </Buttons>
    </Modal>
  );
};

export default ConfirmationModal;
